export const JOBS_API_BASE =
  process.env.REACT_APP_OPPORTUNITY_SCOUT_API_BASE ||
  'https://us-central1-ubunifu-college.cloudfunctions.net/opportunityScoutApi';

export const DEFAULT_FORM = {
  includeKeyword: 'software developer',
  locationName: 'nairobi',
  companyName: '',
  countryName: 'kenya',
  jobType: '',
  datePosted: 'week',
  pagesToFetch: 1,
};

export const COUNTRY_OPTIONS = [
  { value: 'kenya', label: 'Kenya' },
  { value: 'remote', label: 'Remote' },
];

export const JOB_TYPE_OPTIONS = [
  { value: '', label: 'Any job type' },
  { value: 'FULLTIME', label: 'Full-time' },
  { value: 'PARTTIME', label: 'Part-time' },
  { value: 'CONTRACTOR', label: 'Contractor' },
  { value: 'INTERN', label: 'Intern' },
];

export const DATE_POSTED_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: '3days', label: 'Last 3 days' },
  { value: 'week', label: 'Last week' },
  { value: 'month', label: 'Last month' },
];

export const formatDateTime = (value) => {
  if (!value) return '—';
  const dateObj = new Date(value);
  if (Number.isNaN(dateObj.getTime())) return '—';
  return `${dateObj.toLocaleDateString()} • ${dateObj.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

export const formatShortDate = (value) => {
  if (!value) return 'Unknown';
  const dateObj = new Date(value);
  if (Number.isNaN(dateObj.getTime())) return value;
  return dateObj.toLocaleDateString();
};

export const formatLabel = (value) => String(value || '')
  .split(/[_\s]+/)
  .filter(Boolean)
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
  .join(' ');

export const formatCountryLabel = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  const option = COUNTRY_OPTIONS.find((item) => item.value === normalized);
  return option?.label || formatLabel(value);
};

export const parseKeywordList = (value) => String(value || '')
  .split(/[\n,;]+/)
  .map((item) => item.trim())
  .filter(Boolean);

export const getJobDescription = (job = null) => {
  if (!job || typeof job !== 'object') return '';
  const rawJob = job.rawJob || {};
  return [
    rawJob.description,
    rawJob.job_description,
    rawJob.jobDescription,
    rawJob.snippet,
    rawJob.summary,
  ]
    .map((value) => String(value || '').trim())
    .find(Boolean) || '';
};

export const parseResponseJson = async (response) => {
  const rawText = await response.text();
  let data = {};

  if (rawText) {
    try {
      data = JSON.parse(rawText);
    } catch (error) {
      data = {error: rawText};
    }
  }

  if (!response.ok) {
    const error = new Error(data.error || data.message || `Request failed with status ${response.status}`);
    error.statusCode = response.status;
    error.responseData = data;
    if (data.runId) error.runId = data.runId;
    if (data.stage) error.stage = data.stage;
    if (Array.isArray(data.debugLogs)) error.debugLogs = data.debugLogs;
    throw error;
  }

  return data;
};

export const fetchJobsScoutWithAuth = async (auth, path, options = {}) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('You need to be signed in to use Jobs Scout.');
  }

  const idToken = await currentUser.getIdToken();
  const response = await fetch(`${JOBS_API_BASE}${path}`, {
    method: options.method || 'GET',
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  return parseResponseJson(response);
};
